export default {
  title: 'Inspi360-OOTB [basic]',
  source: 'https://d18sazwjyio1h4.cloudfront.net/',
}
